
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"toFill",attrs:{"d":"M25.313 12.656h-10.97V1.687A.845.845 0 0013.5.844H1.687a.844.844 0 00-.843.844v23.625a.844.844 0 00.843.843h23.625a.844.844 0 00.844-.843V13.5a.844.844 0 00-.843-.844zM2.53 2.531h10.125V24.47h-2.531v-3.375a.845.845 0 00-.844-.844H5.906a.844.844 0 00-.843.844v3.375H2.53V2.53zM6.75 24.47v-2.532h1.687v2.532H6.75zm17.719 0H14.344V14.344h10.125v10.125zM5.906 5.906H4.22V4.22h1.687v1.687zm2.531 0H6.75V4.22h1.687v1.687zm2.532 0H9.28V4.22h1.688v1.687zM5.906 8.437H4.22V6.75h1.687v1.687zm2.531 0H6.75V6.75h1.687v1.687zm2.532 0H9.28V6.75h1.688v1.687zM5.906 10.97H4.22V9.28h1.687v1.688zm2.531 0H6.75V9.28h1.687v1.688zm2.532 0H9.28V9.28h1.688v1.688zM5.906 13.5H4.22v-1.688h1.687V13.5zm2.531 0H6.75v-1.688h1.687V13.5zm2.532 0H9.28v-1.688h1.688V13.5zm-5.063 2.531H4.22v-1.687h1.687v1.687zm2.531 0H6.75v-1.687h1.687v1.687zm2.532 0H9.28v-1.687h1.688v1.687zm-5.063 2.532H4.22v-1.688h1.687v1.688zm2.531 0H6.75v-1.688h1.687v1.688zm2.532 0H9.28v-1.688h1.688v1.688zm6.75-.844H16.03V16.03h1.688v1.688zm2.531 0h-1.688V16.03h1.688v1.688zm2.531 0h-1.687V16.03h1.687v1.688zM17.72 20.25H16.03v-1.688h1.688v1.688zm2.531 0h-1.688v-1.688h1.688v1.688zm2.531 0h-1.687v-1.688h1.687v1.688zm-5.062 2.531H16.03v-1.687h1.688v1.687zm2.531 0h-1.688v-1.687h1.688v1.687zm2.531 0h-1.687v-1.687h1.687v1.687z","fill":"#042132"}})])
          )
        }
      }
    